import { combineReducers } from 'redux';

import { commonReducer, commonName } from './common';
import { staffName, staffReducer } from 'modules/staff/state';
import { userReducer, userName } from 'modules/user/state';
import { blockEmailReducer, blockEmailName } from 'modules/blockEmail/state';
import { allocationName, allocationReducer } from 'modules/allocation/state';
import { campaignName, campaignReducer } from 'modules/campaign/state';
import { partnerProgramName, partnerProgramReducer } from 'modules/partner-program/state';
import { filterRd, filterName } from 'hooks/withFilter';

export default combineReducers({
  [commonName]: commonReducer,
  [staffName]: staffReducer,
  [userName]: userReducer,
  [blockEmailName]: blockEmailReducer,
  [allocationName]: allocationReducer,
  [campaignName]: campaignReducer,
  [partnerProgramName]: partnerProgramReducer,
  [filterName]: filterRd,
});
